import axios from "axios";
import router from "../router.js";
import { canAccess } from "../admin/permissions.js";

export default {
    decodeJwt(token) {
        try {
            const part = token.split('.')[1]
            const json = atob(part.replace(/-/g, '+').replace(/_/g, '/'))
            return JSON.parse(decodeURIComponent(escape(json)))
        } catch (e) {
            return null
        }
    },
    getToken() {
        try {
            return localStorage.getItem("token") || ""
        } catch (e) {
            return ""
        }
    },
    getPublicToken() {
        try {
            const token = sessionStorage.getItem("public_token")
            if (token) return token
        } catch (e) { /* noop */ }
        try {
            return localStorage.getItem("public_token") || ""
        } catch (e) {
            return ""
        }
    },
    getPublicRequestToken() {
        return this.getPublicToken() || this.getToken()
    },
    setPublicToken(token) {
        try { sessionStorage.setItem("public_token", token) } catch (e) { /* noop */ }
        try { localStorage.setItem("public_token", token) } catch (e) { /* noop */ }
    },
    getPayload(token) {
        const raw = token || this.getToken()
        return this.decodeJwt(raw) || {}
    },
    getRoles(token) {
        const payload = this.getPayload(token)
        const roles = payload && payload.roles
        return Array.isArray(roles) ? roles : []
    },
    isTokenValid(token) {
        if (!token) return false
        const payload = this.decodeJwt(token)
        if (!payload) return false
        const exp = payload.exp
        if (exp && Number(exp) * 1000 <= Date.now()) return false
        return true
    },
    clearSession() {
        try { localStorage.removeItem("token") } catch (e) { /* noop */ }
        try { localStorage.removeItem("public_token") } catch (e) { /* noop */ }
        try { sessionStorage.removeItem("public_token") } catch (e) { /* noop */ }
        delete axios.defaults.headers.common["Authorization"]
        this.authenticated = false
    },
    isPrivilegedToken(token) {
        if (!token) return false
        const payload = this.decodeJwt(token)
        if (!payload) return false
        const roles = Array.isArray(payload.roles) ? payload.roles : []
        const universities = Array.isArray(payload.universities) ? payload.universities : []
        return roles.length > 0 || universities.length > 0
    },
    async startSessionForTenant(tenant) {
        const r = await axios
            .post(
                `/session`,
                { tenant: tenant }
            );
        axios.defaults.headers.common["Authorization"] =
            "Bearer " + r.data.token;
        const existing = this.getToken()
        this.setPublicToken(r.data.token)
        if (!this.isPrivilegedToken(existing)) {
            localStorage.setItem("token", r.data.token);
        }
    },
    async setTokensForLoggedIn(tokens, redirect = false) {
        axios.defaults.headers.common["Authorization"] =
            "Bearer " + tokens.token;
        localStorage.setItem("token", tokens.token);
        this.authenticated = true;
        if (redirect) {
            // Auto-redirect: send users with specialized roles to the chooser.
            const roles = this.getRoles(tokens.token)
            const canChoose = ['snapshotBulk', 'shareTemplates', 'uploadNotifications', 'ordersAnalytics', 'analytics', 'imports', 'clipsExplorer', 'customerOperations', 'userManagement', 'supportReview']
                .some((permissionKey) => canAccess(roles, permissionKey))
            const target = canChoose ? "/admin/choose" : "/admin/upload"
            await router.push({ path: target });
        }
    },

    // authentication status
    authenticated: false,

    // Send a request to the login URL and save the returned JWT
    login(creds, redirect) {
        return axios.post('/login', creds)
            .then((response) => response.data)
            .then((data) => {
                if (data.mfa_required) {
                    return {
                        mfaRequired: true,
                        challengeId: data.challenge_id,
                        expiresAt: data.expires_at,
                    };
                }
                return this.setTokensForLoggedIn(data.tokens, redirect).then(() => ({
                    mfaRequired: false,
                    tokens: data.tokens,
                }));
            });
    },

    verifyMfa(payload, redirect) {
        return axios.post('/login/mfa', payload)
            .then((response) => response.data)
            .then((data) => this.setTokensForLoggedIn(data.tokens, redirect).then(() => data));
    },

    // To log out
    logout: function () {
        this.clearSession()
        router.push('/admin/login')
    }
}
